module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8505/img/map.svg"